import { Box, Typography } from "@mui/material";
import { toToman } from "../../utils/Utils";
import StartManualInvest from "../../assets/images/start-manual-invest.svg";
import { ReactComponent as InfoIcon } from "../../assets/icons/info-colored.svg";

function InfoBox({ sx = [], ...props }) {
  const { title, description } = props;
  return (
    <Box
      sx={[
        {
          width: "100%",
          p: "16px",
          borderRadius: "12px",
          display: "flex",
          flexDirection: "column",
          bgcolor: "grey.7",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <InfoIcon width={18} height={18} />
        <Typography ml="8px" variant="h5" color="grey.2">
          {title}
        </Typography>
      </Box>

      <Box
        sx={{
          mt: "12px",
        }}
      >
        <Typography component={"div"} variant="subtitle1" color="grey.3">
          {description}
        </Typography>
      </Box>
    </Box>
  );
}

export default InfoBox;
